<template>
  <div class="container_box">
    <Tabs v-model="systemType" :animated="false" class="tabs_styles">
      <TabPane v-for="item in systemTypeList" :label="item.name" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <Button type="primary" @click="addGuideBtn('add')" v-if="getPermission('ymsOperatingInstructions_save')">{{ $t('key1003012') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="550"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--新增指引弹窗-->
    <editGuideModal ref="editGuide" @updateData="getList()"></editGuideModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import editGuideModal from "@/views/yms/components/contentManage/editGuideModal.vue";

export default {
  name: 'operatingInstructions',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      systemType: '3',
      systemTypeList: [
        /* {value: 1, name: '分销商系统'},
         {value: 2, name: '运营系统'},*/
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014')},
      ],
      guidanceTypeList: [
        {type: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003000')},
        /*{type: 2, name: '站内链接'},*/
        {type: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003001')},
      ],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003002'),
          key: 'title',
          minWidth: 130,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003003'),
          key: 'moduleName',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003004'), // 1.PDF文件 2.站内链接 3.在线内容
          key: 'type',
          minWidth: 100,
          align: 'left',
          render(h, params) {
            let type = params.row.type;
            let text = '';
            v.guidanceTypeList.map((item) => {
              if (item.type === type) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003005'),
          key: 'sortNo',
          minWidth: 100,
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
            ];
            let status = params.row.status;
            return h('Badge', {
              props: {
                status: typeList[status].type,
                text: typeList[status].text || '--'
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            let createdTime = params.row.createdTime;
            let time = createdTime ? v.$uDate.dealTime(createdTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477'),
          key: 'updatedTime',
          minWidth: 170,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'left',
          width: 170,
          render(h, params) {
            let status = params.row.status; // 1启用  0停用
            let ymsOperatingInstructionsId = params.row.ymsOperatingInstructionsId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsOperatingInstructions_update'),
                    clickFn: () => {
                      v.$refs['editGuide'].initGuideData('edit', v.systemType, v.guidanceTypeList, ymsOperatingInstructionsId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsOperatingInstructions_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(0, ymsOperatingInstructionsId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsOperatingInstructions_disable'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.enableDisableBtn(1, ymsOperatingInstructionsId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsOperatingInstructions_delete'),
                    clickFn: () => {
                      v.deleteGuideBtn(ymsOperatingInstructionsId);
                    }
                  }
                ]
              },
              on: { // 动态设置操作的宽度
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取指引列表数据
    getList() {
      this.tableData = [];
      if (this.getPermission('ymsOperatingInstructions_queryList')) {
        this.tableLoading = true;
        let systemType = Number(this.systemType);
        this.axios.get(api.get_ymsOperatingInstructions_queryList + systemType).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            this.tableData = data;
            this.$nextTick(() => {
              this.tableLoading = false;
            });
          } else {
            this.tableLoading = false;
          }
        });
      } else {
        this.gotoError();
      }
    },
    // 新增指引
    addGuideBtn(type) {
      this.$refs['editGuide'].initGuideData(type, this.systemType, this.guidanceTypeList);
    },
    // 启用、停用按钮
    enableDisableBtn(status, ymsOperatingInstructionsId) {
      let v = this;
      let url = '';
      let text = '';
      // 停用
      if (status === 1) {
        url = api.put_ymsOperatingInstructions_disable + ymsOperatingInstructionsId;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472');
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003006'),
          content: '<span class="crimsonRedColor">' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003007') + '</span>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003008'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            enableDisableFun(url, text);
          },
          onCancel: () => {
          }
        });
      }
      // 启用
      else {
        url = api.put_ymsOperatingInstructions_enable + ymsOperatingInstructionsId;
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473');
        enableDisableFun(url, text);
      }

      function enableDisableFun(url, text) {
        v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          if (res.data.code === 0) {
            v.$Message.success(text);
            v.getList();
          }
        });
      }
    },
    // 删除指引
    deleteGuideBtn(ymsOperatingInstructionsId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003009'),
        content: '<span class="crimsonRedColor">' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003010') + '</span>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003011'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsOperatingInstructions_delete + ymsOperatingInstructionsId,
            null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.getList();
            }
          });
        },
        onCancel: () => {
        }
      });
    }
  },
  components: {
    editGuideModal
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin-bottom: 8px;
  }
}
</style>